<template>
  <div class="w-100">
    <div class="mt- d-flex align-self-start">
      <div
        class="position-relative align-self-center d-flex align-items-center align-self-center"
      >
        <div
          class="circle-number d-flex justify-content-center align-items-center"
        >
          <span>{{ number }}</span>
        </div>
      </div>
      <div class="pl-3 d-flex">
        <div class="align-self-start mt-1">
          <h2 class="size-1_4 m-0 pb-1">
            <strong v-text="$ml.get('programObjective')"
              >Objetivo do Programa</strong
            >
          </h2>
          <p class="d-flex align-items-center">
            <span
              class="align-self-center"
              v-text="$ml.get('aGoodObjectiveAvoids')"
            >
              Um objetivo bem definido evita problemas, caso tenha algum
              problema nos consulte.
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="d-flex align-self-start h-profile">
      <div class="v-line d-flex align-items-stretch">
        <span class="pb-4"></span>
      </div>
    </div>
    <div class="d-flex align-self-start h-profile-circle">
      <div class="circle d-flex justify-content-center">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>
      <div class="d-flex flex-column w-100 mr-3">
        <p class="pl-3 m-0" v-text="$ml.get('titleTarget')">
          Título do objetivo
        </p>
        <div
          class="card card-body ml-2 pl-3 d-flex w-100 pr-3"
          style="box-shadow: none"
        >
          <form class="col-24 col-md-17 col-lg-9">
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                v-model="title"
                :placeholder="$ml.get('targetPlaceholder')"
              />
              <label
                v-show="titleError"
                class="lblError"
                v-text="$ml.get('titleTargetError')"
                >Por favor, preencha o título objetivo do programa.</label
              >
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="d-flex align-self-start h-profile">
      <div class="v-line d-flex align-items-stretch">
        <span class="pb-4"></span>
      </div>
    </div>

    <div class="d-flex align-self-start h-profile-circle">
      <div class="circle d-flex justify-content-center">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>
      <div class="d-flex flex-column w-100 mr-3">
        <p class="pl-3 mb-2" v-text="$ml.get('nowTellUsLittleObjective')">
          Agora nos fale um pouco do objetivo do programa!
        </p>
        <div
          class="card card-body ml-2 pl-3 d-flex w-100 pr-3"
          style="box-shadow: none"
        >
          <form>
            <div class="col">
              <svg
                v-show="!htmlText"
                @click="viewHtml()"
                width="24"
                height="24"
                class="ico-view-report"
              >
                <image
                  xlink:href="../../../assets/icons/eye.svg"
                  width="24"
                  height="24"
                />
              </svg>
              <svg
                v-show="htmlText"
                @click="htmlText = ''"
                width="24"
                height="24"
                class="ico-view-report"
              >
                <image
                  xlink:href="../../../assets/icons/eye-slash.svg"
                  width="24"
                  height="24"
                />
              </svg>

              <textarea
                v-show="!htmlText"
                class="form-control-textarea w-100 text-are-mark"
                v-model="policy"
                ref="textarea"
                placeholder="Adicione o objetivo do programa..."
                rows="5"
              >
              </textarea>

              <div
                v-show="htmlText"
                class="form-control w-100 h-100"
                v-html="htmlText"
              ></div>
              <div v-show="errorPolicy" class="mb-3">
                <label class="lblError" v-text="$ml.get('targetRequired')"
                  >Por favor, preencha o objetivo do programa</label
                >
              </div>
              <div v-if="errorList" class="mb-3">
                <label class="lblError" v-text="$ml.get('maxProgram')"
                  >Atenção! É permitido no máximo 5 objetivos por programa.
                </label>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Tipo de moeda -->
    <div class="d-flex align-self-start h-profile-circle">
      <div class="circle d-flex justify-content-center flex-row">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>

      <div class="d-flex flex-column w-100 mr-3">
        <div class="row w-100 d-flex pl-3">
          <div class="col-24 d-flex align-items-center justify-content-between">
            <div class="d-flex col" style="gap: 15px">
              <div class="form-group col-9">
                <p
                  class="mb-1"
                  v-text="$ml.get('selectCurrencyType')"
                  style="white-space: nowrap"
                >
                  Selecione o tipo de moeda
                </p>
                <multiselect
                  v-model="optionSelected"
                  :options="listOptions"
                  :searchable="false"
                  label="value"
                  :custom-label="langCurrency"
                  :close-on-select="true"
                  :show-labels="false"
                  :allow-empty="false"
                  :preselect-first="true"
                  :multiple="false"
                >
                </multiselect>
              </div>
              <div class="form-group col-9">
                <p
                  class="mb-1"
                  style="white-space: nowrap"
                  v-text="$ml.get('setProgramReward')"
                >
                  Defina a recompensa do programa
                </p>
                <div style="position: relative">
                  <label v-show="isDollar" class="currency">US$</label>
                  <label v-show="!isDollar" class="currency real">R$</label>
                  <money
                    class="form-control mask-real"
                    v-model="bounty"
                    placeholder="R$ 0,00"
                    maxLength="20"
                  />
                  <label
                    v-if="errorBounty"
                    class="lblError"
                    v-text="$ml.get('requiredBounty')"
                    >Por favor, insira um valor</label
                  >
                  <label
                      v-if="bounty < 0"
                      class="lblError"
                      v-text="$ml.get('labelCurrencyValue')"
                    >
                      {{ $ml.get("invalidValueBudget") }}
                    </label>
              </div>
              </div>
            </div>
            <button class="btn" @click="addProgram" v-text="$ml.get('include')">
              Incluir
            </button>
          </div>
        </div>
        <div style="height: 25px"></div>
      </div>
    </div>
    <div v-if="listProgramsSelected.length">
      <div
        class="d-flex align-self-start h-profile-circle"
        v-for="(program, index) in listProgramsSelected.filter(
          (it) => !it.delete,
        )"
        :key="index"
      >
        <div class="col" v-if="!program.delete && !program.finishedAt">
          <div class="d-flex align-self-start h-profile-circle">
            <div class="circle d-flex justify-content-center">
              <span class="circle-internal d-flex justify-content-center"
                ><span class="circle-primary"></span
              ></span>
              <div class="h-line"><span></span></div>
              <div class="v-line"><span></span></div>
            </div>

            <div class="d-flex flex-column w-100 mr-3 mb-3">
              <p v-if="!program.edit" class="pl-3 m-0" style="font-weight: 400">
                {{ program.title }}
              </p>
              <div
                v-else
                class="card card-body ml-2 pl-3 d-flex w-100 pr-3"
                style="box-shadow: none"
              >
                <form class="col-24 col-md-17 col-lg-9">
                  <input
                    type="text"
                    class="form-control"
                    v-model="program.title"
                    :placeholder="$ml.get('targetPlaceholder')"
                  />
                </form>
              </div>
            </div>
          </div>

          <div class="d-flex align-self-start h-profile">
            <div class="v-line d-flex align-items-stretch">
              <span class="pb-4"></span>
            </div>
          </div>
          <div class="d-flex align-self-start h-profile-circle">
            <div class="circle d-flex justify-content-center">
              <div class="v-line"><span></span></div>
            </div>
            <div class="d-flex flex-column w-100 mr-3">
              <p
                v-show="program.edit"
                class="pl-3 mb-2"
                v-text="$ml.get('nowTellUsLittleObjective')"
              >
                Agora nos fale um pouco do objetivo do programa!
              </p>
              <div
                class="card card-body ml-2 pl-3 d-flex w-100 pr-3"
                style="box-shadow: none"
              >
                <form style="position: relative">
                  <div class="col">
                    <svg
                      width="16"
                      height="16"
                      class="ico-view-report close"
                      @click="removeProgram(program, index)"
                    >
                      <image
                        xlink:href="../../../assets/icons/trash-alt.svg"
                        width="16"
                        height="16"
                      />
                    </svg>
                    <svg
                      @click="program.edit = !program.edit"
                      width="16"
                      height="16"
                      class="ico-view-report edit"
                    >
                      <image
                        xlink:href="../../../assets/icons/edit.png"
                        width="16"
                        height="16"
                      />
                    </svg>
                    <textarea
                      v-show="program.edit"
                      class="form-control-textarea w-100 text-are-mark"
                      v-model="program.policy"
                      ref="textarea"
                      placeholder="Adicione o objetivo do programa..."
                      rows="5"
                    >
                    </textarea>
                    <div
                      v-show="!program.edit"
                      class="form-control w-100 h-100"
                    >
                      <p v-html="$utils.convertMarkedOld(program.policy)"></p>
                      <p>
                        <span
                          class="bounty"
                          v-if="program.currency.value?.toUpperCase() === 'BRL'"
                        >
                          {{ $utils.convertMoney(program.bounty) }}
                        </span>
                        <span v-else class="bounty">
                          {{ $utils.convertDollar(program.bounty) }}
                        </span>
                      </p>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <!-- Tipo de moeda -->
          <div
            class="d-flex align-self-start h-profile-circle"
            v-if="program.edit"
          >
            <div class="circle d-flex justify-content-center flex-row">
              <div class="v-line"><span></span></div>
            </div>
            <div class="d-flex flex-column w-100 mr-3">
              <div class="row w-100 d-flex pl-3">
                <div
                  class="col-24 d-flex align-items-center justify-content-between"
                >
                  <div class="d-flex col" style="gap: 15px">
                    <div class="form-group col-9">
                      <p
                        class="mb-1"
                        v-text="$ml.get('selectCurrencyType')"
                        style="white-space: nowrap"
                      >
                        Selecione o tipo de moeda
                      </p>
                      <multiselect
                        v-model="program.currency"
                        :options="listOptions"
                        :searchable="false"
                        label="value"
                        :custom-label="langCurrency"
                        :close-on-select="true"
                        :show-labels="false"
                        :allow-empty="false"
                        :preselect-first="true"
                        :multiple="false"
                      >
                      </multiselect>
                    </div>
                    <div class="form-group col-9">
                      <p
                        class="mb-1"
                        style="white-space: nowrap"
                        v-text="$ml.get('setProgramReward')"
                      >
                        Defina a recompensa do programa
                      </p>
                      <div style="position: relative">
                        <label
                          v-if="program.currency.value.toUpperCase() === 'BRL'"
                          class="currency real"
                          >R$</label
                        >
                        <label v-else class="currency">US$</label>
                        <money
                          class="form-control mask-real"
                          v-model="program.bounty"
                          placeholder="R$ 0,00"
                          maxLength="20"
                        />
                      </div>
                    </div>
                  </div>
                  <button
                    class="btn"
                    @click="
                      saveProgram(
                        index,
                        program.title,
                        program.policy,
                        program.currency,
                        program.bounty,
                      )
                    "
                    v-text="$ml.get('save')"
                  >
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div style="height: 25px"></div>
        </div>
      </div>
    </div>
    <div class="d-flex align-self-start h-profile">
      <div class="v-line d-flex align-items-stretch">
        <span class="pb-5"></span>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  name: "ProgramByObjective",
  props: {
    number: {
      type: String,
      required: true,
    },
    htmlText: {
      type: String,
      required: false,
    },
    errorList: {
      type: String,
      required: false,
    },
    errorPolicy: {
      type: String,
      required: false,
    },
    listProgramTarget: {
      type: Array,
      required: false,
    },
    edit: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      title: "",
      titleError: "",
      errorBounty: "",
      isDollar: false,
      bounty: 0,
      policy: `(adicione mais detalhes sobre o objetivo)
- [adicionar descrição do objetivo]`,

      listProgramsSelected: [],

      optionSelected: {
        name: "BRL",
        value: "BRL",
      },
      listOptions: [
        {
          name: "BRL",
          value: "BRL",
        },
        {
          name: "USDT",
          value: "USDT",
        },
      ],
    };
  },
  watch: {
    title() {
      this.titleError = "";
    },
    optionSelected() {
      this.isDollar = this.optionSelected.value === "USDT" ? true : false;
    },
    policy() {
      this.errorPolicy = "";
    },
    bounty() {
      this.errorBounty = "";
    },
    listProgramTarget() {
      this.listError = "";
    },
  },
  mounted() {
    if (this.listProgramTarget?.length) {
      this.listProgramsSelected = this.listProgramTarget;
    }
  },
  methods: {
    saveProgram(idx, title, policy, currency, bounty) {
      if (!title || !policy || !bounty) {
        Swal.fire({
          icon: "info",
          title: "",
          text: this.$ml.get("swalTarget"),
        });
        return;
      }
      this.listProgramsSelected[idx].title = title;
      this.listProgramsSelected[idx].policy = policy;
      this.listProgramsSelected[idx].currency = currency;
      this.listProgramsSelected[idx].bounty = bounty;
      this.listProgramsSelected[idx].edit = false;

      if (this.edit) {
        this.$emit("updatedTargets", {
          updatedTargets: this.listProgramsSelected,
        });
        return;
      }

      this.$emit("registeredPrograms", {
        registeredPrograms: this.listProgramsSelected,
      });

      Swal.fire({
        icon: "success",
        title: this.$ml.get("updateTarget"),
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    },
    removeProgram(program, index) {
      var self = this;

      Swal.fire({
        title: self.$ml.get("areYouSureYouWantToDeleteThisTarget"),
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#730ba9",
        customClass: {
          cancelButton: "btn-outline-extra",
        },
        confirmButtonText: self.$ml.get("remove"),
        cancelButtonText: self.$ml.get("cancel"),
      }).then((result) => {
        if (result.value) {
          if (this.edit) {
            if (!program.translated_title) {
              this.listProgramsSelected.splice(index, 1);
              this.$emit("updatedTargets", {
                updatedTargets: this.listProgramsSelected,
              });
              this.errorList = "";
              return;
            }
            program.delete = true;

            this.$emit("updatedTargets", {
              updatedTargets: this.listProgramsSelected,
            });

            this.errorList = "";
            return;
          }
          this.errorList = "";
          this.listProgramsSelected.splice(index, 1);

          this.$emit("registeredPrograms", {
            registeredPrograms: this.listProgramsSelected,
          });

          Swal.fire({
            icon: "success",
            title: this.$ml.get("removeTargetProgram"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      });
    },
    addProgram() {
      if(this.bounty < 0){
        return
      }
      if (!this.title) {
        this.titleError = "error";
        return;
      }
      if (this.bounty === 0) {
        this.errorBounty = "error";
        return;
      }
      if (!this.policy) {
        this.errorPolicy = "error";
        return;
      }

      const maxTarget = 5;
      const filterProgramsSelected = this.listProgramsSelected.filter(
        (target) => target.finishedAt === null || !target.finishedAt,
      );

      const filterDeleted = filterProgramsSelected.filter(target => target.delete === false);

      if (filterDeleted?.length === maxTarget) {
        this.errorList = "error";
        return;
      }

      this.listProgramsSelected = [
        ...this.listProgramsSelected,
        {
          title: this.title,
          bounty: this.bounty,
          policy: this.policy,
          currency: {
            name: this.isDollar ? "USDT" : "BRL",
            value: this.isDollar ? "USDT" : "BRL",
          },
          edit: false,
          delete: false,
        },
      ];
      this.$emit("registeredPrograms", {
        registeredPrograms: this.listProgramsSelected,
      });

      this.title = "";
      this.policy = `(adicione mais detalhes sobre o objetivo)
- [adicionar descrição do objetivo]`;
      this.bounty = 0;
    },
    langCurrency({ name }) {
      return `${this.$ml.get(name)}`;
    },
    viewHtml() {
      this.htmlText = "";
      this.htmlText = this.$utils.convertMarkedOld(this.policy);
    },
  },
};
</script>
<style scoped>
.currency {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translate(-50%, -50%);
}
textarea {
  height: auto !important;
}
.card-list > .card-header,
.card-body {
  padding: 5px 10px !important;
}
.close {
  position: absolute;
  top: 4px;
  right: 40px;
  cursor: pointer;
}
.edit {
  position: absolute;
  top: 4px;
  right: 15px;
  cursor: pointer;
}

.bounty {
  font-weight: 500;
  background: #9e9e9e29;
  padding: 3px 10px;
  border-radius: 5px;
}
</style>
